import React from 'react'
import {useRoutes} from "react-router-dom"
import BaseLayout from '@/layouts/BaseLayout'
import Login from '@/pages/Login'
import Home from '@/pages/Home'
import QrLogin from '@/pages/Login/QrLogin'
import Workbench from '@/pages/Workbench'

const routes = [
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/workbench',
        element: <Workbench />
      }
    ]
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/qrlogin',
    element: <QrLogin />
  }
]

const Router = () => {
  return useRoutes(routes)
}

export default Router
